<template>
  <div class="law-firm">
    <cube-scroll
      ref="scroll"
      :data="list"
      :options="options"
      @pulling-up="onPullingUp"
    >
      <ul class="list">
        <li v-for="(item, i) in list" :key="i">
          <div class="title">{{ item.name }}</div>
          <div class="info">负责人：{{ item.personName }}</div>
          <div class="info">地址：{{ item.address }}</div>
          <div class="phone-box">
            <icon-svg icon-class="phone" className="phone"></icon-svg>
            <span @click="toCall(item.phone)">{{ item.phone }}</span>
          </div>
        </li>
      </ul>
    </cube-scroll>
  </div>
</template>

<script>
import { getLawFirmList } from "@/api/api";

export default {
  name: "lawFirm",
  data() {
    return {
      list: [],
      options: {
        click: true,
        pullUpLoad: {
          threshold: 0,
          txt: {
            more: "",
            noMore: "暂无更多数据",
          },
        },
        scrollbar: false,
      },
      pageIndex: 0,
    };
  },
  methods: {
    getLawFirmList() {
      getLawFirmList(this.pageIndex).then((res) => {
        if (!res.data.length) {
          // 无数据
          this.$refs.scroll.forceUpdate();
        }
        if (this.list == 0) {
          this.list = res.data;
        } else {
          res.data.forEach((v) => {
            this.list.push(v);
          });
        }
      });
    },
    onPullingUp() {
      this.pageIndex++;
      this.getLawFirmList();
    },
    toCall(phone) {
      window.eshimin.phoneCall({
        num: phone.replace("-", ""),
        onResponse: function (res) {
          console.log("phoneCall res:" + res);
        },
      });
    },
  },
  created() {
    this.getLawFirmList();

    window.eshimin.setTitle({
      title: "法律机构",
      onResponse: function (res) {
        console.log("setTitle res:" + res);
      },
    });
  },
};
</script>

<style lang="less" scoped>
.law-firm {
  margin-top: 62px;
  height: calc(100vh - 62px);
  .list {
    li {
      margin-top: 30px;
      .title {
        font-size: 16px;
        color: #333;
        font-weight: 700;
      }
      .info {
        margin-top: 8px;
        font-size: 15px;
        color: #666666;
      }
      .phone-box {
        margin-top: 7px;
        display: flex;
        align-items: center;
        .phone {
          width: 16px;
          height: 16px;
        }
        span {
          margin-left: 8px;
          font-size: 15px;
          color: #666666;
        }
      }
    }
  }
}
</style>
